import { create } from 'zustand';
import { ApplicationAction, ApplicationStore } from './application.type';

const initialState: ApplicationStore = {
  isLoading: false,
};

export const useApplicationStore = create<ApplicationStore & ApplicationAction>(
  (set) => ({
    ...initialState,
    setLoading: () => set({ isLoading: true }),
    removeLoading: () => set({ isLoading: false }),
  }),
);
